<template>
  <div class="heard-course">
    <!-- //信息采集记录 -->
    <el-row class="t-header">
      <el-col :span="10">课程名称</el-col>
      <el-col :span="10">类型</el-col>
      <el-col :span="4">时间</el-col>
    </el-row>
    <el-row class="content" v-if="resultData.list&&resultData.list.length>0" v-loading="tableLoading">
      <el-row class="content-item" v-for="(item,index) in resultData.list" :key="index">
        <el-row class="info">
          <el-col :span="10">{{item.course_name}}</el-col>
          <el-col :span="10">
            <span v-show="item.state==1">语音直播</span>
            <span v-show="item.state==2">语音录播</span>
            <span v-show="item.state==3">视频直播</span>
            <span v-show="item.state==4">视频录播</span>
            </el-col>
          <el-col :span="4">{{item.created_at}}</el-col>
        </el-row>
      </el-row>
    </el-row>

    <div class="tc mt40">
       <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="Number(search.page)"
        :page-size="Number(search.size)"
        layout="total, prev, pager, next"
        :total="Number(resultData.count)"
      ></el-pagination>
    </div>
    
  </div>
</template>

<script>
//获取信息采集的记录
import {_userHistoryListen} from '@/api/user.js';

export default {
  created() {
    this.userHistoryListen();
  },
  props:{
    user_id:{
      type:String,
    }
  },
  components: {},
  data() {
    return {
       search: {
        page: 1,
        size: 10
      },
      tableLoading:false,
      // name type num money date
      resultData: {
      }
    };
  },
  methods: {
    //查询信息
    seachList() {
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val
      this.userHistoryListen()
    },
    reply(item) {
      this.privateDialogVisible = true;
    },
     //听课记录
    userHistoryListen() {
      this.tableLoading=true;
      _userHistoryListen({
        params: {
          page: this.search.page,
          size: this.search.size,
          user_id:this.user_id
        }
      }).then(res => {
        this.tableLoading=false;
        if (res.resultCode == 1) {
          this.resultData = res.result;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.heard-course {
  .t-header {
    margin-top: 20px;
    background-color: @table-bg;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    font-weight: bold;
  }
  .content {
    .content-item {
      .info {
        height: 60px;
        line-height: 60px;
        padding: 0 10px;
        font-weight: 500;
        overflow: hidden;
        }
      &:nth-child(2n){
      background-color: #fefefe;
      }
      &:hover{
      background-color: @table-bg;
      }
    }
  }
}
</style>